<template>
  <SimpleDataCard
      :title="'Toplam B2B Sipariş Sayısı'"
      :data="reportCompanyData.totalB2bOrder.toString()"
      :description="'Tüm Zamanlar'"
      :loading="reportCompanyDataLoading"
      route="b2b-order-list"
  >

  </SimpleDataCard>
</template>

<script>

import SimpleDataCard from "@/components/dashboard/SimpleDataCard";
import {numberConverter} from "../../../../helpers";
import {mapState} from "vuex";

export default {
  name: "ToplamB2BSiparisSayisi",
  components:{
    SimpleDataCard
  },
  computed: {
    ...mapState("dashboard",["reportCompanyData","reportCompanyDataLoading"])
  },
  methods:{
    numberConverter
  }
}
</script>

<style scoped>

</style>